/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import trimOnPayload from '../../utils/payloadUtils';
import { CALL_API } from '../middleware';
import {
  DistributorListType,
  RMType,
  addRmDetails,
  AddDistributorRequestBody,
  Trustee,
  AddTrusteeRequestBody,
  AddFundManagerRequestBody,
  AddAifApproverRequestBody,
  FundManager,
  AuthorisedSignatories,
  AddAuthorisedSignatoryRequestBody,
  poaApprover,
  AddPoaApproverRequestBody,
  nationaliyType,
  SubDistributorListType,
  RmWithDistributors,
  AmcAdmin,
  AddAmcAdminRequestBody,
  RTAApprover,
  AmcApprover,
  AddAMCApproverRequestBody,
  AIFListType,
  AMCListType,
} from '../types/api-types';
import {
  GET_DISTRIBUTORS_LIST,
  GET_DISTRIBUTORS_LIST_SUCCESS,
  GET_RM_LIST,
  GET_RM_LIST_SUCCESS,
  ADD_RMS_LIST_SUCCESS,
  ADD_RMS_LIST,
  ADD_DISTRIBUTOR,
  ADD_DISTRIBUTOR_SUCCESS,
  EDIT_DISTRIBUTOR_SUCCESS,
  GET_SUBDISTRIBUTOR_SUCCESS,
  GET_SUBDISTRIBUTOR,
  EDIT_DISTRIBUTOR,
  UPDATE_FUND_MANAGER_SUCCESS,
  UPDATE_FUND_MANAGER,
  UPDATE_TRUSTEE_SUCCESS,
  GET_Countries_SUCCESS,
  GET_Countries,
  UPDATE_TRUSTEE,
  EDIT_RM_SUCCESS,
  EDIT_RM,
  GET_AIF_APPROVER_LIST_SUCCESS,
  GET_AIF_APPROVER_LIST,
  ADD_DISTRIBUTOR_RM_SUCCESS,
  ADD_DISTRIBUTOR_RM,
  UPDATE_DISTRIBUTOR_RM_SUCCESS,
  GET_TRUSTEE_LIST_SUCCESS,
  GET_TRUSTEE_LIST,
  ADD_TRUSTEE_SUCCESS,
  ADD_TRUSTEE,
  GET_FUND_MANAGERS_LIST_SUCCESS,
  GET_FUND_MANAGERS_LIST,
  ADD_FUND_MANAGER_SUCCESS,
  ADD_FUND_MANAGER,
  GET_AUTHORISEDSIGNATORY_LIST_SUCCESS,
  GET_AUTHORISEDSIGNATORY_LIST,
  ADD_AUTHORISEDSIGNATORY_SUCCESS,
  ADD_AUTHORISEDSIGNATORY,
  UPDATE_AUTHORISEDSIGNATORY_SUCCESS,
  UPDATE_AUTHORISEDSIGNATORY,
  GET_POAAPPROVER_LIST_SUCCESS,
  GET_POAAPPROVER_LIST,
  ADD_POAAPPROVER_SUCCESS,
  ADD_POAAPPROVER,
  UPDATE_POAAPPROVER_SUCCESS,
  UPDATE_POAAPPROVER,
  GET_AIFAPPROVERACCESS_SUCCESS,
  GET_AIFAPPROVERACCESS,
  GET_RMBYID,
  GET_RMBYID_SUCCESS,
  GET_DISTRIBUTORRMBYID_SUCCESS,
  GET_DISTRIBUTORRMBYID,
  GET_AUTHORISEDSIGNATORYBYID_SUCCESS,
  GET_AUTHORISEDSIGNATORYBYID,
  GET_POAAPPROVERBYID_SUCCESS,
  GET_POAAPPROVERBYID,
  GET_TRUSTEEBYID_SUCCESS,
  GET_TRUSTEEBYID,
  GET_AIF_APPROVERBYID_SUCCESS,
  GET_AIF_APPROVERBYID,
  GET_FUND_MANAGERSBYID_SUCCESS,
  GET_FUND_MANAGERSBYID,
  GET_DISTRIBUTORSOFRM_BY_RMID_SUCCESS,
  GET_DISTRIBUTORSOFRM_BY_RMID,
  GET_TRUSTEEACCESS,
  GET_TRUSTEEACCESS_SUCCESS,
  GET_IMACCESS_SUCCESS,
  GET_IMACCESS,
  GET_AMCADMINACCESS,
  GET_AMCADMINACCESS_SUCCESS,
  GET_AMCADMIN_LIST_SUCCESS,
  GET_AMCADMIN_LIST,
  GET_AMCADMINBYID,
  GET_AMCADMINBYID_SUCCESS,
  ADD_AMCADMIN_SUCCESS,
  ADD_AMCADMIN,
  UPDATE_AMCADMIN_SUCCESS,
  UPDATE_AMCADMIN,
  UPLOAD_BULK_USERS_SUCCESS,
  UPLOAD_BULK_USERS,
  EXPORT_USERS_SUCCESS,
  EXPORT_USERS,
  GET_REQUIRED_FOR_ESIGN_SUCCESS,
  GET_REQUIRED_FOR_ESIGN,
  SET_REQUIRED_FOR_ESIGN_SUCCESS,
  SET_REQUIRED_FOR_ESIGN,
  ADD_AMC_APPROVER,
  ADD_AMC_APPROVER_SUCCESS,
  ADD_RTA_APPROVER_SUCCESS,
  ADD_RTA_APPROVER,
  EDIT_AMC_APPROVER_SUCCESS,
  EDIT_AMC_APPROVER,
  EDIT_RTA_APPROVER_SUCCESS,
  EDIT_RTA_APPROVER,
} from '../types/onBoarding';

export const getRMsList =
  (params?: { isActive: boolean }) =>
  async (dispatch: any): Promise<RMType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/rm-list`,
        method: 'GET',
        types: [GET_RM_LIST_SUCCESS, GET_RM_LIST],
        params,
      },
    });
  };

export const addBulkUsers =
  (body: any) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/bulk-upload-users`,
        method: 'POST',
        types: [UPLOAD_BULK_USERS_SUCCESS, UPLOAD_BULK_USERS],
        body,
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const exportUsersData =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/export-users`,
        method: 'GET',
        types: [EXPORT_USERS_SUCCESS, EXPORT_USERS],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const getDistributorsList =
  (params: { type: string }) =>
  async (dispatch: any): Promise<DistributorListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors`,
        method: 'GET',
        types: [GET_DISTRIBUTORS_LIST_SUCCESS, GET_DISTRIBUTORS_LIST],
        params,
      },
    });
  };

export const editRM =
  (Id: number, body: addRmDetails) =>
  async (dispatch: any): Promise<RMType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-rm/${Id}`,
        method: 'POST',
        types: [EDIT_RM_SUCCESS, EDIT_RM],
        body: trimOnPayload(body),
      },
    });
  };

export const addRM =
  (body: addRmDetails) =>
  async (dispatch: any): Promise<RMType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-rm`,
        method: 'POST',
        types: [ADD_RMS_LIST_SUCCESS, ADD_RMS_LIST],
        body: trimOnPayload(body),
      },
    });
  };

export const addDistributor =
  (body: AddDistributorRequestBody) =>
  async (dispatch: any): Promise<DistributorListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-distributor`,
        method: 'POST',
        types: [ADD_DISTRIBUTOR_SUCCESS, ADD_DISTRIBUTOR],
        body: trimOnPayload(body),
      },
    });
  };

export const editDistributor =
  (Id: number, body: AddDistributorRequestBody | any) =>
  async (dispatch: any): Promise<DistributorListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-distributor/${Id}`,
        method: 'POST',
        types: [EDIT_DISTRIBUTOR_SUCCESS, EDIT_DISTRIBUTOR],
        body: trimOnPayload(body),
      },
    });
  };

export const getTrustessList =
  (params?: { isActive: boolean }) =>
  async (dispatch: any): Promise<Trustee[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/trustee-list`,
        method: 'GET',
        types: [GET_TRUSTEE_LIST_SUCCESS, GET_TRUSTEE_LIST],
        params,
      },
    });
  };

export const addTrustee =
  (body: AddTrusteeRequestBody) =>
  async (dispatch: any): Promise<Trustee[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-trustee`,
        method: 'POST',
        types: [ADD_TRUSTEE_SUCCESS, ADD_TRUSTEE],
        body: trimOnPayload(body),
      },
    });
  };

export const UpdateTrustee =
  (Id: number, body: AddTrusteeRequestBody) =>
  async (dispatch: any): Promise<DistributorListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-trustee/${Id}`,
        method: 'POST',
        types: [UPDATE_TRUSTEE_SUCCESS, UPDATE_TRUSTEE],
        body: trimOnPayload(body),
      },
    });
  };

export const getFundManagersList =
  (params?: { isActive: boolean }) =>
  async (dispatch: any): Promise<FundManager[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/fundmanager-list`,
        method: 'GET',
        types: [GET_FUND_MANAGERS_LIST_SUCCESS, GET_FUND_MANAGERS_LIST],
        params,
      },
    });
  };

export const getAIFApproverList =
  () =>
  async (dispatch: any): Promise<RTAApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/rtaapprover-list`,
        method: 'GET',
        types: [GET_AIF_APPROVER_LIST_SUCCESS, GET_AIF_APPROVER_LIST],
      },
    });
  };
export const getAMCApproverList =
  () =>
  async (dispatch: any): Promise<AmcApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/amcapprover-list`,
        method: 'GET',
        types: [GET_AIF_APPROVER_LIST_SUCCESS, GET_AIF_APPROVER_LIST],
      },
    });
  };

export const addFundManager =
  (body: AddFundManagerRequestBody) =>
  async (dispatch: any): Promise<FundManager[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-fundmanager`,
        method: 'POST',
        types: [ADD_FUND_MANAGER_SUCCESS, ADD_FUND_MANAGER],
        body: trimOnPayload(body),
      },
    });
  };

export const UpdateFundManager =
  (Id: number, body: AddFundManagerRequestBody) =>
  async (dispatch: any): Promise<DistributorListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-fundmanager/${Id}`,
        method: 'POST',
        types: [UPDATE_FUND_MANAGER_SUCCESS, UPDATE_FUND_MANAGER],
        body: trimOnPayload(body),
      },
    });
  };

export const addAifApprover =
  (body: AddAifApproverRequestBody) =>
  async (dispatch: any): Promise<RTAApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-rtaapprover`,
        method: 'POST',
        types: [ADD_RTA_APPROVER_SUCCESS, ADD_RTA_APPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const addAmcApprover =
  (body: AddAMCApproverRequestBody) =>
  async (dispatch: any): Promise<AmcApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-amcapprover`,
        method: 'POST',
        types: [ADD_AMC_APPROVER_SUCCESS, ADD_AMC_APPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const UpdateAifApprover =
  (Id: number, body: AddAifApproverRequestBody) =>
  async (dispatch: any): Promise<AIFListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-rtaapprover/${Id}`,
        method: 'POST',
        types: [EDIT_RTA_APPROVER_SUCCESS, EDIT_RTA_APPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const UpdateAmcApprover =
  (Id: number, body: AddAMCApproverRequestBody) =>
  async (dispatch: any): Promise<AMCListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-amcapprover/${Id}`,
        method: 'POST',
        types: [EDIT_AMC_APPROVER_SUCCESS, EDIT_AMC_APPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const getAuthorisedSignatoryList =
  (params?: { distributorId: number }) =>
  async (dispatch: any): Promise<AuthorisedSignatories[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/authorisedsignatory-list`,
        method: 'GET',
        types: [GET_AUTHORISEDSIGNATORY_LIST_SUCCESS, GET_AUTHORISEDSIGNATORY_LIST],
        params,
      },
    });
  };

export const addAuthorisedSignatory =
  (body: AddAuthorisedSignatoryRequestBody) =>
  async (dispatch: any): Promise<AuthorisedSignatories[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-authorisedsignatory`,
        method: 'POST',
        types: [ADD_AUTHORISEDSIGNATORY_SUCCESS, ADD_AUTHORISEDSIGNATORY],
        body: trimOnPayload(body),
      },
    });
  };

export const updateAuthorisedSignatory =
  (authorisedSignatoryId: number, body: AddAuthorisedSignatoryRequestBody) =>
  async (dispatch: any): Promise<AuthorisedSignatories[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-authorisedsignatory/${authorisedSignatoryId}`,
        method: 'POST',
        types: [UPDATE_AUTHORISEDSIGNATORY_SUCCESS, UPDATE_AUTHORISEDSIGNATORY],
        body: trimOnPayload(body),
      },
    });
  };

export const getPoaApproverList =
  (params?: { distributorId: number }) =>
  async (dispatch: any): Promise<poaApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/poaapprover-list`,
        method: 'GET',
        types: [GET_POAAPPROVER_LIST_SUCCESS, GET_POAAPPROVER_LIST],
        params,
      },
    });
  };

export const addDistributorRM =
  (body: any) =>
  async (dispatch: any): Promise<DistributorListType[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-subdistributor`,
        method: 'POST',
        types: [ADD_DISTRIBUTOR_RM_SUCCESS, ADD_DISTRIBUTOR_RM],
        body: trimOnPayload(body),
      },
    });
  };

export const updateDistributorRM =
  (Id: number, body: any) =>
  async (dispatch: any): Promise<SubDistributorListType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-subdistributor/${Id}`,
        method: 'POST',
        types: [UPDATE_DISTRIBUTOR_RM_SUCCESS, UPDATE_POAAPPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const addPOAAppprover =
  (body: AddPoaApproverRequestBody) =>
  async (dispatch: any): Promise<poaApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-poaapprover`,
        method: 'POST',
        types: [ADD_POAAPPROVER_SUCCESS, ADD_POAAPPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const updatePOAApprover =
  (POAapproverId: number, body: AddPoaApproverRequestBody) =>
  async (dispatch: any): Promise<poaApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-poaapprover/${POAapproverId}`,
        method: 'POST',
        types: [UPDATE_POAAPPROVER_SUCCESS, UPDATE_POAAPPROVER],
        body: trimOnPayload(body),
      },
    });
  };

export const getDistributorById =
  (
    DistributorId: string | number,
    params?: { subdistributorType?: string; isTopupApplicable?: boolean; parentShareClass?: string }
  ) =>
  async (dispatch: any): Promise<poaApprover[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors/${DistributorId}`,
        method: 'GET',
        types: [GET_SUBDISTRIBUTOR_SUCCESS, GET_SUBDISTRIBUTOR],
        params,
      },
    });
  };

export const getNationalityList =
  () =>
  async (dispatch: any): Promise<nationaliyType> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/default-countries.json',
        method: 'GET',
        types: [GET_Countries_SUCCESS, GET_Countries],
      },
    });
  };

export type AifApproverAccess = {
  rtaApproverAccess: boolean;
};
export type AmcApproverAccess = {
  amcApproverAccess: boolean;
};

export const getAmcApproverAccess =
  () =>
  async (dispatch: any): Promise<AmcApproverAccess> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/amcApproverAccess`,
        method: 'GET',
        types: [GET_AIFAPPROVERACCESS_SUCCESS, GET_AIFAPPROVERACCESS],
      },
    });
  };

export const getRtaApproverAccess =
  () =>
  async (dispatch: any): Promise<AifApproverAccess> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/rtaApproverAccess`,
        method: 'GET',
        types: [GET_AIFAPPROVERACCESS_SUCCESS, GET_AIFAPPROVERACCESS],
      },
    });
  };

export const getRMById =
  (rmId: number) =>
  async (dispatch: any): Promise<RMType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/rms/${rmId}`,
        method: 'GET',
        types: [GET_RMBYID_SUCCESS, GET_RMBYID],
      },
    });
  };

export const getDistributorRMbyId =
  (Id: number) =>
  async (dispatch: any): Promise<SubDistributorListType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/subdistributors/${Id}`,
        method: 'GET',
        types: [GET_DISTRIBUTORRMBYID_SUCCESS, GET_DISTRIBUTORRMBYID],
      },
    });
  };

export const getAuthorisedSignatoryById =
  (id: number) =>
  async (dispatch: any): Promise<AuthorisedSignatories> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/authorisedsignatories/${id}`,
        method: 'GET',
        types: [GET_AUTHORISEDSIGNATORYBYID_SUCCESS, GET_AUTHORISEDSIGNATORYBYID],
      },
    });
  };
export const getPoaApproverById =
  (Id: number) =>
  async (dispatch: any): Promise<poaApprover> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/poaapprovers/${Id}`,
        method: 'GET',
        types: [GET_POAAPPROVERBYID_SUCCESS, GET_POAAPPROVERBYID],
      },
    });
  };

export const getTrustesById =
  (id: number) =>
  async (dispatch: any): Promise<Trustee> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/trustees/${id}`,
        method: 'GET',
        types: [GET_TRUSTEEBYID_SUCCESS, GET_TRUSTEEBYID],
      },
    });
  };
export const getFundManagersById =
  (id: number) =>
  async (dispatch: any): Promise<FundManager> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/fundmanagers/${id}`,
        method: 'GET',
        types: [GET_FUND_MANAGERSBYID_SUCCESS, GET_FUND_MANAGERSBYID],
      },
    });
  };

export const getRTAApproverById =
  (Id: number) =>
  async (dispatch: any): Promise<FundManager> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/rtaapprovers/${Id}`,
        method: 'GET',
        types: [GET_AIF_APPROVERBYID_SUCCESS, GET_AIF_APPROVERBYID],
      },
    });
  };

export const getAMCApproverById =
  (Id: number) =>
  async (dispatch: any): Promise<FundManager> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/amcapprovers/${Id}`,
        method: 'GET',
        types: [GET_AIF_APPROVERBYID_SUCCESS, GET_AIF_APPROVERBYID],
      },
    });
  };

export const getDistributorAndSRMByRmid =
  (rmId: number) =>
  async (dispatch: any): Promise<RmWithDistributors> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors-of-rm-by-id/${rmId}`,
        method: 'GET',
        types: [GET_DISTRIBUTORSOFRM_BY_RMID_SUCCESS, GET_DISTRIBUTORSOFRM_BY_RMID],
      },
    });
  };

export type trusteeAccess = {
  trusteeAccess: boolean;
};
export const gettrusteeAccess =
  () =>
  async (dispatch: any): Promise<trusteeAccess> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/trusteeAccess`,
        method: 'GET',
        types: [GET_TRUSTEEACCESS_SUCCESS, GET_TRUSTEEACCESS],
      },
    });
  };
//IM-->Investment Manager or fundManager
export type IMAccess = {
  fundManagerAccess: boolean;
};
export const getIMAccess =
  () =>
  async (dispatch: any): Promise<IMAccess> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/fundManagerAccess`,
        method: 'GET',
        types: [GET_IMACCESS_SUCCESS, GET_IMACCESS],
      },
    });
  };

export type AmcAdminAccess = {
  amcAdminAccess: boolean;
};
export const getAmcAdminAccess =
  () =>
  async (dispatch: any): Promise<AmcAdminAccess> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/amcAdminAccess`,
        method: 'GET',
        types: [GET_AMCADMINACCESS_SUCCESS, GET_AMCADMINACCESS],
      },
    });
  };

export const getAmcAdminList =
  () =>
  async (dispatch: any): Promise<AmcAdmin[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/amcadmin-list`,
        method: 'GET',
        types: [GET_AMCADMIN_LIST_SUCCESS, GET_AMCADMIN_LIST],
      },
    });
  };

export const getAMCAdminById =
  (Id: number) =>
  async (dispatch: any): Promise<AmcAdmin> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/amcadmins/${Id}`,
        method: 'GET',
        types: [GET_AMCADMINBYID_SUCCESS, GET_AMCADMINBYID],
      },
    });
  };

export const addAmcAdmin =
  (body: AddAmcAdminRequestBody) =>
  async (dispatch: any): Promise<AmcAdmin[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/add-amcadmin`,
        method: 'POST',
        types: [ADD_AMCADMIN_SUCCESS, ADD_AMCADMIN],
        body: trimOnPayload(body),
      },
    });
  };

export const updateAmcAdmin =
  (amcAdminId: number, body: AddAmcAdminRequestBody) =>
  async (dispatch: any): Promise<AmcAdmin[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/update-amcadmin/${amcAdminId}`,
        method: 'POST',
        types: [UPDATE_AMCADMIN_SUCCESS, UPDATE_AMCADMIN],
        body: trimOnPayload(body),
      },
    });
  };

export type getRequiredForEsignType = { authorisedSignatoryThreshold: number };

export const getRequiredForEsign =
  (distributorId: number) =>
  async (dispatch: any): Promise<getRequiredForEsignType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/get-authorised-signatory-threshold-for-esign/${distributorId}`,
        method: 'GET',
        types: [GET_REQUIRED_FOR_ESIGN_SUCCESS, GET_REQUIRED_FOR_ESIGN],
      },
    });
  };

export const setRequiredForEsign =
  (body: getRequiredForEsignType & { distributorId: number }) =>
  async (dispatch: any): Promise<getRequiredForEsignType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/set-authorised-signatory-threshold-for-esign`,
        method: 'POST',
        types: [SET_REQUIRED_FOR_ESIGN_SUCCESS, SET_REQUIRED_FOR_ESIGN],
        body,
      },
    });
  };
